import { HighAlertColumn } from '../../../models/high-alert-column.model';
import { HighAlert } from '../../../models/high-alert.model';

/**
 * Columns definition for the HighAlert table
 */
export const HIGH_ALERT_COLUMNS: readonly HighAlertColumn[] = [
  { key: 'checkbox', header: '', accessor: (l: HighAlert) => '' },
  { key: 'program', header: 'Program', accessor: (l: HighAlert) => l.programName },
  { key: 'window', header: 'Window', accessor: (l: HighAlert) => l.window },
  { key: 'startDate', header: 'Start Date', accessor: (l: HighAlert) => l.startDate },
  { key: 'endDate',   header: 'End Date',   accessor: (l: HighAlert) => l.endDate },
  { key: 'notes', header: 'Notes', accessor: (l: HighAlert) => l.notes },
  { key: 'action', header: '', accessor: (l: HighAlert) => '' },
] as const;
